import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=064fa5db&scoped=true&lang=pug&"
import script from "./ConfirmButton.vue?vue&type=script&lang=js&"
export * from "./ConfirmButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064fa5db",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
